import { render, staticRenderFns } from "./healingUserInfo.vue?vue&type=template&id=5e455a0a&scoped=true&"
import script from "./healingUserInfo.vue?vue&type=script&lang=js&"
export * from "./healingUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./healingUserInfo.vue?vue&type=style&index=0&id=5e455a0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e455a0a",
  null
  
)

export default component.exports